function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 64 64"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M30.16 11.51 6.84 51.9a2.13 2.13 0 0 0 1.84 3.19h46.64a2.13 2.13 0 0 0 1.84-3.19L33.84 11.51a2.13 2.13 0 0 0-3.68 0",
  style: {
    fill: "#efcc00"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M29 46a3 3 0 1 1 3 3 2.88 2.88 0 0 1-3-3m1.09-4.66-.76-15h5.26l-.73 15Z",
  style: {
    fill: "#353535"
  }
}));
export default SvgWarning;